import React from 'react';
import { Link } from 'react-router-dom';

function About() {
  return (
    <>
      {/* <!-- Header Banner --> */}
      <section className="banner-header bg-img bg-fixed" data-overlay-dark="5" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/banner/20.jpg)` }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="subtitle">Black Rock Luxury Hotel</div>
              <div className="title">About Hotel</div>
            </div>
          </div>
        </div>
      </section>

      {/* About section */}
      <section className="about-section">

        {/* Main: text + images */}
        <div className="about-main">
          <div className="container">
            <div className="about-main__inner">

              {/* Images */}
              <div className="about-main__imgs">
                <img src={`${process.env.PUBLIC_URL}/img/about01.jpg`} alt="" className="about-img about-img--large" />
                <img src={`${process.env.PUBLIC_URL}/img/about04.jpg`} alt="" className="about-img about-img--small" />
              </div>

              {/* Text */}
              <div className="about-main__text">
                <div className="about-main__label">About Black Rock</div>
                <h2 className="about-main__title">Our Mission & Values</h2>
                <div className="about-main__divider" />
                <p className="about-main__lead">
                  At Black Rock, our mission is simple: <em>to provide the hospitality that creates unique experiences.</em>
                </p>
                <p className="about-main__body">
                  Rooted in nature, shaped by nomadic tradition, and elevated with modern luxury — we believe true hospitality is felt, not just seen.
                </p>
                <div className="about-main__stats">
                  <div className="about-stat">
                    <div className="about-stat__num">4</div>
                    <div className="about-stat__label">Suite rooms</div>
                  </div>
                  <div className="about-stat__sep" />
                  <div className="about-stat">
                    <div className="about-stat__num">76 m²</div>
                    <div className="about-stat__label">Largest suite</div>
                  </div>
                  <div className="about-stat__sep" />
                  <div className="about-stat">
                    <div className="about-stat__num">100%</div>
                    <div className="about-stat__label">Lakeview</div>
                  </div>
                </div>
                <Link to="/rooms" className="about-main__btn">Explore Rooms</Link>
              </div>

            </div>
          </div>
        </div>
        
      </section>
    </>
  );
}

export default About;